// extracted by mini-css-extract-plugin
module.exports = {"titleAccordion":"Accordion_titleAccordion__VijTJ","mobileMenu":"Accordion_mobileMenu__2XvJV"};